




























import Vue from 'vue'
import WarningDialog from '@/components/WarningDialog.vue'
import { FETCH_TOOLS, RUN_TOOLS } from '@/store/action-types'
import { GetToolsResponse, RunToolResponse } from '@/types/service-response'
import { Tools } from '@/model/Tools'
import ProgressCircular from '@/components/ProgressCircular.vue'
import { TranslateResult } from 'vue-i18n'
import { SnackbarStateEnum } from '@/types/enums'

interface ComponentData {
  loading: boolean
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  showWarningDialog: boolean
  warningMessage: string
  toolList: Tools[]
  selectedToolCode: string | undefined
}

export default Vue.extend({
  name: 'ToolsPage',

  components: {
    ProgressCircular,
    WarningDialog
  },

  data (): ComponentData {
    return {
      loading: false,
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      showWarningDialog: false,
      warningMessage: '',
      toolList: [],
      selectedToolCode: undefined
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    }
  },

  methods: {
    onToolClick (item: Tools): void {
      this.warningMessage = item.question
      this.showWarningDialog = true
      this.selectedToolCode = item.code ? item.code : undefined
    },

    onWarningDialogClose (): void {
      this.selectedToolCode = undefined
      this.showWarningDialog = false
    },

    async onWarningDialogSave (): Promise<void> {
      if(this.selectedToolCode) {
        try {
          this.loading = true
          const response: RunToolResponse = await this.$store.dispatch(RUN_TOOLS, this.selectedToolCode)
          this.loading = false
          if (!response.IsError && response.Found) {
            this.selectedToolCode = undefined
            this.showWarningDialog = false
            this.messageSnackbar = 'Der Versand wurde ausgeführt.'
            this.snackbarState = SnackbarStateEnum.Success
            this.showSnackbar = true
          } else {
            this.messageSnackbar = this.$t('errors.functionCouldNotBeExecuted')
            this.snackbarState = SnackbarStateEnum.Error
            this.showSnackbar = true
          }
        } catch {
          this.loading = false
          this.messageSnackbar = this.$t('errors.functionCouldNotBeExecuted')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      }
    },

    async fetchData (): Promise<void> {
      try {
        this.loading = true
        const response: GetToolsResponse = await this.$store.dispatch(FETCH_TOOLS)
        this.loading = false
        if(!response.IsError) {
          this.toolList = Tools.createFromResponse(response.Tools)
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.loading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    }
  },

  mounted(): void {
    this.fetchData()
  }
})
